import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#468fed",
      light: "#77c1fe",
      moonGlow: "#77c1fe",
    },
    secondary: {
      dark: "#000000",
      main: "#000000",
      light: "#ffffff",
      tuna: "#343A40",
      greyChateau: "#A6A9AC",
    },
    text: {
      davyGrey: "#525252",
      coolGrey: "#8692A6",
      charcoalGrey: "#696F79",
      gunSmoke: "#747677",
      darkBlue:"#2871cf",
      appLightBlue:"#d4ecff87"
    },
    gradient: {
      background:
        "linear-gradient(270deg, #77c1fe 0%, #5099f7 25.77%, #468fed 69.77%, #2871cf 100%)",
      button:
        "linear-gradient(270deg, #77c1fe 0%, #5099f7 25.77%, #468fed 69.77%, #2871cf 100%)",
    },
  },

  typography: {
    color: "#000000",
    fontFamily: ["Roboto", "Inter", "sans-serif"].join(","),

    primaryText: {
      fontFamily: "Poppins",
      fontWeight: 600,
      fontSize: "2.125rem",
      color: "#525252",
      lineHeight: 1.2,
    },
    secondaryText: {
      fontFamily: "Poppins",
      fontWeight: 400,
      fontSize: "1rem",
      color: "#8692A6",
      lineHeight: 1.2,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: ["Roboto", "Inter", "sans-serif"].join(","),
          textTransform: "capitalize",
          borderRadius: "10px",
          width: "100%",
          height: "100%",
          boxShadow: "none",
          padding: "10px",
          fontSize: "0.875rem",
          fontWeight: 500,
        },
        contained: {
          color: "#ffffff",
          backgroundColor: "#0B090A",
          border: "1px solid #0B090A",
          "&:hover": {
            backgroundColor: "#0B090A",
          },
        },
        outlined: {
          backgroundColor: "transparent",
          color: "#EA580C",
          border: "1px solid #A6A9AC",
          "&:hover": {
            backgroundColor: "transparent",
            border: "1px solid #A6A9AC",
          },
        },
        custom_gradient: {
          color: "#ffffff",
          borderRadius: "100px",
          background:
            "linear-gradient(270deg, #77c1fe 0%, #5099f7 25.77%, #468fed 69.77%, #2871cf 100%)",
          "&:hover": {
            background:
              "linear-gradient(270deg, #77c1fe 0%, #5099f7 25.77%, #468fed 69.77%, #2871cf 100%)",
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
      },
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "50px",
            backgroundColor: "#ffffff",
            "& .MuiOutlinedInput-input": {
              padding: "14px 14px 14px 25px",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #468fed`,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #468fed`,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #468fed`,
            },
          },
          "& .Mui-error": {
            "& .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #d32f2f !important`,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #d32f2f !important`,
            },
          },
          "& .MuiFormHelperText-root": {
            marginLeft: 0,
            marginTop: 0,
          },
          "& .Mui-disabled": {
            cursor: "not-allowed",
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#d4ecff87",
          "& .MuiFilledInput-input": {
            padding: "12px",
            "&:hover": {
              backgroundColor: "#d4ecff87",
            },
          },
          "&:before": {
            borderBottom: `2px solid #468fed`,
          },
          "&:after": {
            borderBottom: `2px solid #468fed`,
          },
          "&:hover:before": {
            borderBottom: `1px solid #468fed`,
          },
          "&.Mui-focused": {
            backgroundColor: "#d4ecff87",
          },
        },
      },
    },
  },
});

export default theme;
